import { render, staticRenderFns } from "./CompareTableChoices.vue?vue&type=template&id=b14170b2&scoped=true&"
import script from "./CompareTableChoices.vue?vue&type=script&lang=ts&"
export * from "./CompareTableChoices.vue?vue&type=script&lang=ts&"
import style0 from "./CompareTableChoices.vue?vue&type=style&index=0&id=b14170b2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b14170b2",
  null
  
)

export default component.exports